import React from 'react'
import type { Playlist } from 'types/playlist'
import { MixpanelEventLocationProvider } from 'contexts/mixpanel-event-location'
import PlaylistInfo from 'components/common/playlist-info'
import Row from 'components/common/row'
import PlaylistActions from 'components/playlist-actions'
import Flex from 'components/ui/flex'
type Props = {
  playlist: Playlist | null | undefined
}

const ArtistShowcasesPlaylist = ({ playlist }: Props): React.ReactNode => {
  return (
    <Row columnsSize={[12]} marginBottom="small">
      <div>
        <Flex>
          <Flex.Content>
            <PlaylistInfo playlist={playlist} showcase />
          </Flex.Content>
          <div>
            <MixpanelEventLocationProvider
              value={{
                featureContext: 'showcases',
              }}
            >
              <PlaylistActions playlist={playlist} hideShareShortcut />
            </MixpanelEventLocationProvider>
          </div>
        </Flex>
      </div>
    </Row>
  )
}

export default ArtistShowcasesPlaylist
